import type { ArbitraryTypedObject } from '@portabletext/types';
import { PortableTextBlock } from '@sanity/types';
import { getSanityImageUrl } from '@/libs/sanity/client';
import CTA2 from '@/components/CTA2';
import { PortableTextWrapper } from './PortableTextWrapper';
import { TABLET_SCREEN_SIZE } from '@/utils/constants';
import { useMediaQuery } from 'usehooks-ts';
import Image from 'next/image';
type RightTextInsideImageProps = {
  anchor?: string;
  image: any;
  text:
    | (PortableTextBlock | ArbitraryTypedObject)
    | (PortableTextBlock | ArbitraryTypedObject)[];
  ctas: any[];
};

const RightTextInsideImage = ({
  anchor,
  image,
  text,
  ctas,
}: RightTextInsideImageProps) => {
  const isTablet = useMediaQuery(`(max-width: ${TABLET_SCREEN_SIZE}px)`);

  if (isTablet) {
    return (
      <section
        id={anchor}
        className="max-w-8xl mx-auto grid grid-cols-12 gap-0 mt-4 scroll-mt-[150px]"
      >
        <div className="col-span-12 ">
          {text && <PortableTextWrapper value={text} />}
          {ctas && ctas.map((cta: any) => <CTA2 key={cta._key} {...cta} />)}
        </div>
        <div className="col-span-12">
          <Image
            src={getSanityImageUrl(image)}
            alt={image.alt}
            width={1308}
            height={1080}
            className=" object-cover"
          />
        </div>
      </section>
    );
  }

  return (
    <section
      id={anchor}
      className="max-w-8xl mx-auto flex flex-col justify-center items-end mt-4 bg-overlayBg bg-top bg-blend-overlay bg-cover lg:min-h-[550px] scroll-mt-[150px]"
      style={
        image ? { backgroundImage: `url('${getSanityImageUrl(image)}')` } : {}
      }
    >
      <div className="w-full lg:w-1/2 bg-white mt-8 px-8 pt-8 py-6 mr-16 mb-8 rounded">
        {text && <PortableTextWrapper value={text} />}
        {ctas && ctas.map((cta: any) => <CTA2 key={cta._key} {...cta} />)}
      </div>
    </section>
  );
};

export default RightTextInsideImage;
